export default {
    'FINANCIALS_EMPLOYEE': 'FINANCIALS EMPLOYEE', 
    'CONFIRMATION_EMPLOYEE': 'CONFIRMATION EMPLOYEE', 
    'OPERATION_EMPLOYEE': 'OPERATION EMPLOYEE',
    'WAREHOUSE_EMPLOYEE':'WAREHOUSE EMPLOYEE',
    'PRODUCTS_EMPLOYEE': 'PRODUCTS EMPLOYEE'
};